// AURA HOME — Shopify Theme Interactions
(function () {
  document.documentElement.classList.add('js-enabled');

  // ===== DARK MODE TOGGLE =====
  var root = document.documentElement;
  var storedTheme = null;
  try { storedTheme = localStorage.getItem('aura-theme'); } catch (e) {}

  // Auto-detect system dark mode, respect saved preference
  if (storedTheme === 'dark' || storedTheme === 'light') {
    root.setAttribute('data-theme', storedTheme);
  } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    root.setAttribute('data-theme', 'dark');
  } else {
    root.setAttribute('data-theme', 'light');
  }

  // Create toggle button
  var toggle = document.createElement('button');
  toggle.className = 'aura-theme-toggle';
  toggle.setAttribute('aria-label', 'Switch to dark mode');
  toggle.innerHTML =
    '<svg class="moon-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>' +
    '<svg class="sun-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>';

  toggle.addEventListener('click', function () {
    var current = root.getAttribute('data-theme');
    var next = current === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem('aura-theme', next); } catch (e) {}
    toggle.setAttribute('aria-label', 'Switch to ' + (next === 'dark' ? 'light' : 'dark') + ' mode');
  });

  // Insert toggle after DOM is ready
  function insertToggle() {
    if (!document.querySelector('.aura-theme-toggle')) {
      document.body.appendChild(toggle);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertToggle);
  } else {
    insertToggle();
  }

  // ===== REVEAL ON SCROLL =====
  var reveals = document.querySelectorAll('.aura-reveal, .aura-reveal-img');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function (el) { observer.observe(el); });
    setTimeout(function () {
      reveals.forEach(function (el) { el.classList.add('visible'); });
    }, 2500);
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }
})();
